// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sanity-cta[data-v-96fb3e06]{margin-bottom:.5rem;width:100%}@media (min-width:600px){.sanity-cta[data-v-96fb3e06]{margin-bottom:0;margin-right:.5rem;width:auto}}.border-white[data-v-96fb3e06]{border:1px solid #fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
